import api from './client';
import { API_ENDPOINTS } from './endpoints';

export type PaymentMethod = 'ERA' | 'EOB';
export type ClaimStatus = 'paid' | 'unpaid';
export type PostedTrend = 'daily' | 'weekly' | 'monthly';
export type ApprovalStatus = 'pending' | 'approved' | 'rejected';

export interface PaymentPostingApiItem {
  _id: string;
  payment_posting_id?: string;
  payment_id?: string;
  payment_amount?: number;
  payment_date?: string;
  payment_method?: PaymentMethod;
  claim_id?: string;
  claim_amount?: number;
  claim_status?: ClaimStatus;
  adjustment_amount?: number;
  adjustment_reason?: string;
  time_to_post?: number;
  claims_posted_per_user?: number;
  payments_posted?: PostedTrend;
  payments_posted_vs_target?: number;
  approval_status?: ApprovalStatus;
  approval_remarks?: string;
  approved_at?: string;
  rejected_at?: string;
  department_name?: string;
  source?: 'excel_upload' | 'api' | 'manual';
  createdAt?: string;
  updatedAt?: string;
}

export interface PaymentPostingListResponse {
  success: boolean;
  statusCode: number;
  message: string;
  data?: {
    postings?: PaymentPostingApiItem[];
    paymentPostings?: PaymentPostingApiItem[];
    items?: PaymentPostingApiItem[];
    records?: PaymentPostingApiItem[];
    count?: number;
  } | PaymentPostingApiItem[];
}

export interface PaymentPostingMutationResponse {
  success: boolean;
  statusCode: number;
  message: string;
  data?: PaymentPostingApiItem;
}

export interface PaymentPostingActionPayload {
  action: 'approved' | 'rejected';
  remarks?: string;
}

export interface UpsertPaymentPostingPayload {
  payment_id: string;
  payment_amount: number;
  payment_date: string;
  payment_method: PaymentMethod;
  claim_id: string;
  claim_amount: number;
  claim_status: ClaimStatus;
  adjustment_amount: number;
  adjustment_reason: string;
  time_to_post: number;
  claims_posted_per_user: number;
  payments_posted: PostedTrend;
  payments_posted_vs_target: number;
}

export const getPaymentPostings = async (params?: {
  page?: number;
  limit?: number;
  search?: string;
  approval_status?: ApprovalStatus;
  payment_method?: PaymentMethod;
  claim_status?: ClaimStatus;
  [key: string]: string | number | boolean | undefined;
}): Promise<PaymentPostingListResponse> => {
  return api.get<PaymentPostingListResponse>(API_ENDPOINTS.paymentPosting.list, { params });
};

export const getPaymentPostingById = async (id: string): Promise<PaymentPostingMutationResponse> => {
  return api.get<PaymentPostingMutationResponse>(`${API_ENDPOINTS.paymentPosting.list}/${id}`);
};

export const createPaymentPosting = async (payload: UpsertPaymentPostingPayload): Promise<PaymentPostingMutationResponse> => {
  return api.post<PaymentPostingMutationResponse, UpsertPaymentPostingPayload>(API_ENDPOINTS.paymentPosting.list, payload);
};

export const updatePaymentPosting = async (id: string, payload: UpsertPaymentPostingPayload): Promise<PaymentPostingMutationResponse> => {
  return api.put<PaymentPostingMutationResponse, UpsertPaymentPostingPayload>(`${API_ENDPOINTS.paymentPosting.list}/${id}`, payload);
};

export const deletePaymentPosting = async (id: string): Promise<PaymentPostingMutationResponse> => {
  return api.delete<PaymentPostingMutationResponse>(`${API_ENDPOINTS.paymentPosting.list}/${id}`);
};

export const takePaymentPostingAction = async (
  id: string,
  payload: PaymentPostingActionPayload,
): Promise<PaymentPostingMutationResponse> => {
  return api.post<PaymentPostingMutationResponse, PaymentPostingActionPayload>(`${API_ENDPOINTS.paymentPosting.list}/${id}/action`, payload);
};
